import { useArtSpecs } from "./Context";

const showAreas = false;

export const Art = () => {
  const { ref, bp, bpHeight, specs, scale } = useArtSpecs();
  const { pattern } = specs;

  const Yellow = specs.yellow;
  const Purple = specs.purple;
  const Teal = specs.teal;
  const Red = specs.red;
  const Blue = specs.blue;
  const { p10, p20, p30, p40, p50 } = specs.color;

  return (
    <svg
      ref={ref}
      width={bp < 1056 ? "100%" : bp}
      height={bp < 1056 ? "100%" : bpHeight}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${bp} ${bpHeight}`}
      style={{ position: "absolute" }}
    >
      {/* yellow area */}
      {pattern[bp].y && (
        <g transform={`translate(${pattern[bp].y[0]} ${pattern[bp].y[1]}) scale(${scale})`}>
          <Yellow p10={p10} p20={p20} p30={p30} p40={p40} p50={p50} />
          {showAreas && <rect width="384" height="384" fill="#f1c21b" opacity=".5" />}
        </g>
      )}

      {/* purple area */}
      {pattern[bp].p && (
        <g
          transform={
            `translate(${pattern[bp].p[0]} ${pattern[bp].p[1]}) scale(${scale})` +
            (pattern[bp].p[2] ? `translate(384 0) rotate(90) ` : ``)
          }
        >
          <Purple p10={p10} p20={p20} p30={p30} p40={p40} p50={p50} />
          {showAreas && <rect width="192" height="384" fill="#a970ff" opacity=".5" />}
        </g>
      )}

      {/* teal area */}
      {pattern[bp].t && (
        <g transform={`translate(${pattern[bp].t[0]} ${pattern[bp].t[1]}) scale(${scale})`}>
          <Teal p10={p10} p20={p20} p30={p30} p40={p40} p50={p50} />
          {showAreas && <rect width="96" height="96" fill="#009d9a" opacity=".5" />}
        </g>
      )}

      {/* red area */}
      {pattern[bp].r && (
        <g transform={`translate(${pattern[bp].r[0]} ${pattern[bp].r[1]}) scale(${scale})`}>
          <Red p10={p10} p20={p20} p30={p30} p40={p40} p50={p50} />
          {showAreas && <rect width="192" height="192" fill="#fb4b53" opacity=".5" />}
        </g>
      )}

      {/* blue area */}
      {pattern[bp].b && (
        <g transform={`translate(${pattern[bp].b[0]} ${pattern[bp].b[1]}) scale(${scale})`}>
          <Blue p10={p10} p20={p20} p30={p30} p40={p40} p50={p50} />
          {showAreas && <rect width="384" height="384" fill="#1193e8" opacity=".5" />}
        </g>
      )}
    </svg>
  );
};
